export enum ChargeStates {
  PENDING = 'charge_pending',
  SUCCESS = 'charge_succeed',
  FAILED = 'charge_failed',
}
export enum PaymentStates {
  PENDING = 'payment_pending',
  SUCCESS = 'payment_succeed',
  FAILED = 'payment_failed',
}

export interface OrderResponse {
  state: ChargeStates | PaymentStates;
  offer?: Record<string, unknown>;
  publisherErrorMessage?: string;
  publisherPurchaseId?: string;
  purchaseId?: string;
}

export enum PollingStatus {
  IDLE = 'idle',
  POLLING = 'polling',
  SUCCESS = 'success',
  FAILED = 'failed',
}
export interface ProductItem {
  name: string;
  sku: string;
  quantity: string;
}
